// CSV utilities — download, escape, financial year helpers
export function toCSV(rows, columns) {
  const esc = (v) => {
    if (v == null) return '';
    const s = String(v);
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const header = columns.map(c => c.label).join(',');
  const body = rows.map(r => columns.map(c => esc(typeof c.get === 'function' ? c.get(r) : r[c.key])).join(',')).join('\n');
  return header + '\n' + body;
}

export function downloadCSV(filename, csvString) {
  const blob = new Blob(['\ufeff' + csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function parseCSV(text) {
  // Simple CSV parser handling quoted fields with embedded commas & escaped quotes
  const rows = [];
  let cur = [], val = '', inQ = false, i = 0;
  while (i < text.length) {
    const c = text[i];
    if (inQ) {
      if (c === '"' && text[i+1] === '"') { val += '"'; i += 2; continue; }
      if (c === '"') { inQ = false; i++; continue; }
      val += c; i++; continue;
    }
    if (c === '"') { inQ = true; i++; continue; }
    if (c === ',') { cur.push(val); val = ''; i++; continue; }
    if (c === '\n' || c === '\r') {
      if (val !== '' || cur.length) { cur.push(val); rows.push(cur); }
      val = ''; cur = [];
      if (c === '\r' && text[i+1] === '\n') i++;
      i++; continue;
    }
    val += c; i++;
  }
  if (val !== '' || cur.length) { cur.push(val); rows.push(cur); }
  if (!rows.length) return { headers: [], rows: [] };
  const headers = rows[0].map(h => h.trim().replace(/^\ufeff/, ''));
  const dataRows = rows.slice(1).filter(r => r.some(x => x && x.trim())).map(r => Object.fromEntries(headers.map((h, i) => [h, (r[i] || '').trim()])));
  return { headers, rows: dataRows };
}

// Indian Financial Year: Apr 1 to Mar 31
// FY 2026-27 = Apr 2026 – Mar 2027
export function isoToFY(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const startYr = m >= 4 ? y : y - 1;
  return `FY${startYr}-${String((startYr + 1) % 100).padStart(2,'0')}`;
}

export function currentFY() {
  return isoToFY(new Date().toISOString());
}

export function fyRange(fyLabel) {
  // 'FY2026-27' -> {start: '2026-04-01', end: '2027-03-31'}
  const m = fyLabel.match(/^FY(\d{4})-\d{2}$/);
  if (!m) return null;
  const y = parseInt(m[1]);
  return { start: `${y}-04-01`, end: `${y + 1}-03-31` };
}

export function listRecentFYs(n = 5) {
  const cur = currentFY();
  const y = parseInt(cur.match(/^FY(\d{4})/)[1]);
  return Array.from({ length: n }, (_, i) => `FY${y - i}-${String((y - i + 1) % 100).padStart(2,'0')}`);
}
